import React from "react";

//Importar helpers.
import LPChatLogo from "../Logo/LPChatLogo.jsx";
import BtnCompany from "../Buttons/BtnCompany.jsx";
import UserProfileWithRol from "../UserProfileWithRol.jsx";
import BtnChangeModeTheme from "../Buttons/BtnChangeModeTheme.jsx";
import AutoAsingSwitch from "../Switch/AutoAsingSwitch.jsx";

// Navigation: Componente que renderiza la barra de navegacion superior.

const Navigation = ({ onChangeIcons }) => {

    return (
        <nav className="container-navigation__layout">

            {/*-----Logo de LPchat---------*/}
            <LPChatLogo />

            {/*----Botones para cambiar de empresas---*/}
            <BtnCompany onChangeIcons={onChangeIcons}  />

            {/*----Botón para cambiar el modo----*/}
            <BtnChangeModeTheme />

            {/*-----Switch para autoasignarse----*/}
            <AutoAsingSwitch />

            {/*----Usuario con el check para asignarse----*/}
            <UserProfileWithRol />

        </nav>

    )
};

export default Navigation;
